import { notificationsSchema } from "venuescanner-js/constants/user_notifications";

// import { postToApi } from 'venuescanner-js/services/api'
// import serviceURLs from '../serviceURLs.json'
import controllers from "../controllers";

/** @class
 * @name Notification
 * @desc Class definition of a Notification set of settings
 * <br>This Object will have the properties as defined by notificationsSchema in the user_settings file.
 * <br>Setting any of these properties to an enum value, will post and update the user immediately
 */
class Notification {
  constructor(values = {}) {
    this._data = values;
    Object.keys(notificationsSchema).forEach((k) => {
      switch (notificationsSchema[k].type) {
        case String:
          Object.defineProperty(this, k, {
            get: function () {
              return this._data[k];
            },
            set: function (v) {
              // console.log(k,v);
              if (
                notificationsSchema[k].enum &&
                !notificationsSchema[k].enum.includes(v)
              )
                return;
              if (this._data[k] != v) {
                this._data[k] = v;
                this.changed();
              }
            },
          });
          break;
        default:
          this[k] = values[k];
      }
    });
  }
  changed() {
    controllers.userService.notifications
      .post({ notifications: this._data })
      .then(() => {
        console.log("Updated");
      });
  }
}

export default Notification;
